<div class="update-banner" [ngStyle]="{'display': updateAvailable ? 'flex': 'none'}" >
    <span class="text">A new version of PRISMPdM is available.</span>
    <!-- <span class="me-auto"></span> -->
    <button mat-flat-button type="button" color="primary" (click)="reload()">Install Now</button>
</div>

<router-outlet></router-outlet>

<div *ngIf="showCookieBanner" class="cookie-banner" style="z-index: 999;">
    <!-- Banner -->
    <span class="text">This website uses cookies to ensure you get the best experience.</span>
    <span class="app-icon--cancel" ><mat-icon (click)="acknowledgeCookies()"/></span>
</div>

<div class="loading-shade" *ngIf="showSpinner==true">
	<mat-spinner strokeWidth="2"></mat-spinner>
</div>
<!-- <app-chatbot></app-chatbot> -->